"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenancePageLayoutInteractor = void 0;
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const core_2 = require("../../core");
require("./StateInfoLoadableModel");
const types_1 = require("./types");
class MaintenancePageLayoutInteractor extends core_1.Interactor {
    constructor(stateInfoLoadableModel, presenters) {
        super();
        this.stateInfoLoadableModel = stateInfoLoadableModel;
        this.presenters = presenters;
        this.subscriptions = new rxjs_1.Subscription();
        this.stateInfoLoadableModel = stateInfoLoadableModel;
        this.presenters = presenters;
    }
    willActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            const stateInfoObservable = rxjs_1.defer(() => this.stateInfoLoadableModel.load()).pipe(operators_1.switchMap(() => {
                const response = this.stateInfoLoadableModel.getValue();
                if (response.restoreState === types_1.RESTORE_STATE.maintenanceMode) {
                    throw response;
                }
                this.presenters.onLogOut();
                return rxjs_1.of(response);
            }), operators_1.retryWhen((errors) => errors.pipe(operators_1.delay(MaintenancePageLayoutInteractor.RESTORE_STATE_POOLING_INTERVAL), operators_1.map((error) => {
                if (error instanceof Error) {
                    throw error;
                }
                return error;
            }))), operators_1.catchError(core_2.catchErrorHandler(this.presenters.onCatchError)));
            this.subscriptions.add(stateInfoObservable.subscribe());
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.unsubscribe();
        });
    }
}
exports.MaintenancePageLayoutInteractor = MaintenancePageLayoutInteractor;
MaintenancePageLayoutInteractor.RESTORE_STATE_POOLING_INTERVAL = 30000;
//# sourceMappingURL=MaintenancePageLayoutInteractor.js.map